module.exports = __webpack_public_path__ + "static/media/main_myjob_icon_2.5188a3e4.svg";